import { call, put, takeLatest } from 'redux-saga/effects';
import TicketRITMAction, {
  TicketRITMTypes,
} from 'redux/actions/ticketRITMAction';
import {
  getRequestTicket,
  searchRequestTicket,
} from 'services/ticketServices';
import BaseAction from '../actions/baseAction';

export function* getListRITMTicket(action: any): any {
  try {
    const result = yield call(getRequestTicket, action.params);
    if (result.status === 200) {
      yield put(TicketRITMAction.getListRITMTicketSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketRITMAction.getListRITMTicketFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_LIST_RITM_TICKET ${error}`,
      }),
    );
  }
}

export function* getMoreListRITM(action: any): any {
  try {
    const result = yield call(getRequestTicket, action.params);
    if (result.status === 200) {
      yield put(TicketRITMAction.getMoreListRITMSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketRITMAction.getMoreListRITMFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_MORE_LIST_RITM ${error}`,
      }),
    );
  }
}

export function* searchRITMTicket(action: any): any {
  try {
    const result = yield call(searchRequestTicket, action.params);
    if (result.status === 200) {
      yield put(TicketRITMAction.searchRITMTicketSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketRITMAction.searchRITMTicketFail());
    yield put(
      BaseAction.errorHandling({
        message: `SEARCH_RITM_TICKET ${error}`,
      }),
    );
  }
}

export function* getMoreListRITMWithSearch(action: any): any {
  try {
    const result = yield call(searchRequestTicket, action.params);
    if (result.status === 200) {
      yield put(TicketRITMAction.getMoreListRITMSuccessWithSearch(result.data));
    }
  } catch (error) {
    yield put(TicketRITMAction.getMoreListRITMWithSearchFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_MORE_LIST_RITM_WITH_SEARCH ${error}`,
      }),
    );
  }
}

export const watchTicketRITM = [
  takeLatest(TicketRITMTypes.GET_LIST_RITM_TICKET, getListRITMTicket),
  takeLatest(TicketRITMTypes.GET_MORE_LIST_RITM, getMoreListRITM),
  takeLatest(TicketRITMTypes.SEARCH_RITM_TICKET, searchRITMTicket),
  takeLatest(
    TicketRITMTypes.GET_MORE_LIST_RITM_WITH_SEARCH,
    getMoreListRITMWithSearch,
  ),
];
